import { VaUsagePerBillingCycleResponse } from "../../api-models/response/user/VaUsagePerBillingCycleResponse";
import { RowItemData } from "../../components/datatable/interfaces";
import dateService from "../date-service/DateService";
import { translationService } from "../translation/TranslationService";

export class VaUsagePerBillingCycle implements RowItemData {
  id: number;
  private billingCycle: Date;
  private billingPeriodStart: Date;
  private billingPeriodEnd: Date;
  private totalVaCalls: number;

  constructor(vaUsagePerBillingCycleOutput: VaUsagePerBillingCycleResponse) {
    this.id = vaUsagePerBillingCycleOutput.id;
    this.billingCycle = vaUsagePerBillingCycleOutput.billingCycle;
    this.billingPeriodStart = vaUsagePerBillingCycleOutput.billingPeriodStart;
    this.billingPeriodEnd = vaUsagePerBillingCycleOutput.billingPeriodEnd;
    this.totalVaCalls = vaUsagePerBillingCycleOutput.totalVaCalls;
  }

  get displayValues() {
    return {
      billingCycle: {
        toDisplay: `${translationService.translate(
          "general.billing-date"
        )} ${dateService.formatDate(this.billingCycle)}`,
      },
      billingPeriodStart: { toDisplay: dateService.formatDate(this.billingPeriodStart) },
      billingPeriodEnd: { toDisplay: dateService.formatDate(this.billingPeriodEnd) },
      totalVaCalls: { toDisplay: this.totalVaCalls },
    };
  }

  get path(): any {
    return undefined;
  }
}
